if (!customElements.get('piecework-full-width-moment')) {
  customElements.define(
    'piecework-full-width-moment',
    class PieceworkFullWidthMoment extends HTMLElement {
      constructor() {
        super();
      }
      setMargin() {
        const fullWidthMove = window.innerWidth - this.getBoundingClientRect().width;
        const fullWidthMoveHalf = fullWidthMove / -2;
        this.style.setProperty('--full-width-move', `${fullWidthMoveHalf}px`);
      }
      connectedCallback() {
        this.setMargin();
        window.addEventListener('resize', this.setMargin.bind(this));
      }
    }
  );
}
